import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.article`
  border-left: 4px solid ${Colours.lime};
  background-color: ${Colours.whiteDark1};
  padding: 30px;
  margin: 2rem 0 0;

  a {
    margin-bottom: 3rem;
  }

  .before-link {
    margin-bottom: 0.5rem;
  }

  .optional-label {
    padding: 6px 10px;
    background-color: ${Colours.grey};
    border-radius: 3px;
    color: ${Colours.white};
    font-size: 10px;
    line-height: 19px;
  }
`;
